import { FC } from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

export type PieChartData = {
  name: string;
  value: number;
  color: string;
};

export const AppPieChart: FC<{ data: PieChartData[] }> = ({ data }) => {
  const isEmpty = data.length === 0 || data.every((item) => item.value === 0);
  const isSingleColored = data.filter(x => !!x.value).length === 1;
  const chartData = isEmpty ? [{ name: 'Empty', value: 1 }] : data;

  return (
    <ResponsiveContainer width={'100%'} height={'100%'}>
      <PieChart>
        <Pie
          data={chartData}
          dataKey={'value'}
          nameKey={'name'}
          outerRadius={'100%'}
          innerRadius={'60%'}
          isAnimationActive={false}
          startAngle={90}
          endAngle={450}
          stroke={'none'}
          strokeWidth={0}
          paddingAngle={isSingleColored ? 0 : 1}
        >
          {isEmpty ? <Cell fill="#dfe2e2" /> : data.map((entry) => <Cell key={entry.name} fill={entry.color} />)}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};
